
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import LaunchButton from '@/components/LaunchButton';

interface ThankYouErrorStateProps {
  errorMessage: string;
}

const ThankYouErrorState: React.FC<ThankYouErrorStateProps> = ({ errorMessage }) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Alert variant="destructive" className="max-w-md">
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>{errorMessage}</AlertDescription>
        <div className="mt-4">
          <LaunchButton
            variant="outline"
            className="w-full mt-2"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Return to Homepage
          </LaunchButton>
        </div>
      </Alert>
    </div>
  );
};

export default ThankYouErrorState;
